(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4395],{

/***/ 81815:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-center/[serviceCenterId]/[serviceCenterSlug]",
      function () {
        return __webpack_require__(62378);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 94316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89659);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        " !important;\n  text-decoration: underline;\n  cursor: pointer;\n  p {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CardRowText__StyledText",
    componentId: "sc-d731630f-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$font) && "font-family: ".concat(p === null || p === void 0 ? void 0 : p.$font, ";");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$fontSize) && "font-size: ".concat(p === null || p === void 0 ? void 0 : p.$fontSize, "px;");
});
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CardRowText__StyledContent",
    componentId: "sc-d731630f-1"
})(_templateObject1());
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "CardRowText__StyledLink",
    componentId: "sc-d731630f-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var CardRowText = function(param) {
    var data = param.data, iconName = param.iconName, _link = param.link, link = _link === void 0 ? "" : _link, _iconInMobile = param.iconInMobile, iconInMobile = _iconInMobile === void 0 ? false : _iconInMobile, font = param.font, fontSize = param.fontSize, imageAlt = param.imageAlt, trackEvent = param.trackEvent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            onClick: function() {
                return trackEvent && trackEvent();
            },
            children: [
                iconName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: iconInMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .Mobile */ .ij, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                            src: "/icons/".concat(iconName, ".svg"),
                            alt: imageAlt
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                        src: "/icons/".concat(iconName, ".svg"),
                        alt: imageAlt
                    })
                }),
                link !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
                    href: link,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                        $font: font,
                        $fontSize: fontSize,
                        children: data
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                    $font: font,
                    $fontSize: fontSize,
                    children: data
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardRowText);


/***/ }),

/***/ 1094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reusable_BackButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./reusable/icons/BackIcon.tsx






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.coffeeBrown */.Z.coffeeBrown : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 25;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.97 2.516a.75.75 0 0 1 1.061 0l9 9a.75.75 0 0 1 0 1.062l-9 9a.751.751 0 0 1-1.062-1.062l8.47-8.47-8.47-8.468a.75.75 0 0 1 0-1.062Z",
            fill: color
        })
    }));
};
/* harmony default export */ var BackIcon = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/BackButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border-bottom: none;\n  margin: 0px;\n  &:hover {\n    border-bottom: none;\n    margin: 0px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "BackButton__StyledButton",
    componentId: "sc-7b449b6d-0"
})(_templateObject(), function(p) {
    return p.theme.colors.onyx;
}, function(p) {
    return p.theme.colors.onyx;
});
var BackButton = function() {
    var back = (0,router.useRouter)().back;
    var handleBack = function() {
        back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {
                width: "14px",
                height: "14px",
                color: colors/* default.onyx */.Z.onyx
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                $fontSize: "16px",
                $fontWeight: "300",
                $color: "rgb(86, 96, 102)",
                onClick: handleBack,
                children: "חזרה"
            })
        ]
    });
};
/* harmony default export */ var reusable_BackButton = (BackButton);


/***/ }),

/***/ 99763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ formsComp_FormErrorState; }
});

// UNUSED EXPORTS: StyledSubTitle, StyledSvgContainer, StyledTitle

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./reusable/formsComp/FormWarningSvgIcon.tsx

var FormSvgIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "76",
        height: "76",
        viewBox: "0 0 76 76",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.00003 67.5829C1.00321 66.2685 1.30426 64.9844 1.86593 63.859L32.6659 4.50703C32.6662 4.5064 32.6665 4.50578 32.6668 4.50515C33.2415 3.4123 34.0413 2.526 34.9763 1.9184C35.9102 1.31147 36.9511 1 38 1C39.0489 1 40.0898 1.31147 41.0237 1.9184C41.9585 2.52588 42.7582 3.41196 43.3328 4.50453C43.3333 4.50536 43.3337 4.5062 43.3341 4.50703L74.1309 63.8526C74.132 63.8548 74.1331 63.8571 74.1342 63.8593C74.6958 64.9846 74.9968 66.2686 75 67.5829C75.0032 68.8997 74.7072 70.1884 74.1488 71.3192C73.5906 72.4498 72.7943 73.3741 71.853 74.0134C70.9152 74.6504 69.8629 74.9852 68.7995 75H7.20053C6.13714 74.9852 5.08483 74.6504 4.147 74.0134C3.20572 73.3741 2.40944 72.4498 1.85117 71.3192C1.29278 70.1884 0.996831 68.8997 1.00003 67.5829Z",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.4492 26.1016L38.4492 53.1016",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.4492 59.2031H38.4856",
                stroke: "black",
                "stroke-width": "6",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./reusable/formsComp/FormErrorState.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 27px;\n  letter-spacing: 0em;\n  max-width: 325px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormErrorState__StyledWrapper",
    componentId: "sc-215887c-0"
})(_templateObject());
var StyledSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormErrorState__StyledSvgContainer",
    componentId: "sc-215887c-1"
})(_templateObject1());
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "FormErrorState__StyledTitle",
    componentId: "sc-215887c-2"
})(_templateObject2());
var StyledSubTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "FormErrorState__StyledSubTitle",
    componentId: "sc-215887c-3"
})(_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var FormErrorState = function(param) {
    var _title = param.title, title = _title === void 0 ? "משהו השתבש" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "נראה שמשהו השתבש ולא הצלחנו לרשום אותך. אנחנו נשוב אלייך מאוחר יותר." : _subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvgContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSvgIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                variant: "h2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubTitle, {
                variant: "body1",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ var formsComp_FormErrorState = (FormErrorState);


/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ }),

/***/ 62378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _serviceCenterSlug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/BackButton.tsx + 1 modules
var BackButton = __webpack_require__(1094);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./common/ElementRatio.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 100%;\n  position: relative;\n  min-height: 1px;\n  height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 100%;\n  position: relative;\n  height: 0;\n  padding-bottom: calc(100% / ",
        ");\n  > img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var DEFAULT_MOBILE_WIDTH = 360;
var StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ElementRatio__StyledDiv",
    componentId: "sc-41ef23d7-0"
})(_templateObject(), function(p) {
    return p.height + "px";
});
var StyledCssDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ElementRatio__StyledCssDiv",
    componentId: "sc-41ef23d7-1"
})(_templateObject1(), function(p) {
    return p.ratio;
});
var RatioElement = function(param) {
    var _ratio = param.ratio, ratio = _ratio === void 0 ? 1 : _ratio, children = param.children, css = param.css, _debug = param.debug, debug = _debug === void 0 ? false : _debug;
    var ref = (0,react.useState)(DEFAULT_MOBILE_WIDTH / ratio), height = ref[0], setHeight = ref[1];
    var ref1 = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (css) return;
        var listener = function() {
            if (ref1.current) {
                // eslint-disable-next-line no-debugger
                if (debug) debugger;
                setHeight(ref1.current.clientWidth / ratio);
            }
        };
         true ? listener() : 0;
        window.addEventListener("resize", listener);
        return function() {
            return window.removeEventListener("resize", listener);
        };
    }, [
        ratio,
        css,
        debug
    ]);
    return css ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCssDiv, {
        ratio: ratio,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiv, {
        height: height,
        ref: ref1,
        children: children
    });
};
/* harmony default export */ var ElementRatio = (RatioElement);

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./common/CloseButton.tsx + 1 modules
var CloseButton = __webpack_require__(92217);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(50067);
;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/aboutUs/ServiceCenterGalleryDialog.tsx


function ServiceCenterGalleryDialog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  justify-content: center;\n  ",
        " {\n    margin: 0;\n  }\n"
    ]);
    ServiceCenterGalleryDialog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceCenterGalleryDialog_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 60px);\n  height: calc(100% - 60px);\n  z-index: 0;\n  margin: 30px;\n  .swiper-slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    ServiceCenterGalleryDialog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  right: 0;\n  svg {\n    path {\n      fill: white;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: swiper-icons;\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-size: 55px;\n  cursor: pointer;\n  user-select: none;\n  color: white;\n  visibility: ",
        ";\n  &.swiper-button-disabled {\n    opacity: 0.3;\n  }\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* ",
        ' */\n  position: absolute;\n  top: 50%;\n  left: 30px;\n  :after {\n    content: "prev";\n  }\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* ",
        ' */\n  position: absolute;\n  top: 50%;\n  right: 30px;\n\n  :after {\n    content: "next";\n  }\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  width: 1280px;\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 100%;\n  padding-bottom: calc(100% / (16 / 9));\n  position: relative;\n  iframe {\n    width: 100%;\n    height: 100%;\n    max-height: 100vh;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var buttonCSS = (0,styled_components_browser_esm/* css */.iv)(ServiceCenterGalleryDialog_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledSwiper",
    componentId: "sc-7661b8e9-0"
})(ServiceCenterGalleryDialog_templateObject1());
var StyledCloseButton = (0,styled_components_browser_esm/* default */.ZP)(CloseButton/* default */.Z).withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledCloseButton",
    componentId: "sc-7661b8e9-1"
})(_templateObject2());
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledImage",
    componentId: "sc-7661b8e9-2"
})(_templateObject3());
var SwiperButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "ServiceCenterGalleryDialog__SwiperButton",
    componentId: "sc-7661b8e9-3"
})(_templateObject4(), function(p) {
    return p.$visible ? "visible" : "hidden";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButtonNext = (0,styled_components_browser_esm/* default */.ZP)(SwiperButton).withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledButtonNext",
    componentId: "sc-7661b8e9-4"
})(_templateObject5(), buttonCSS);
var StyledButtonPrev = (0,styled_components_browser_esm/* default */.ZP)(SwiperButton).withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledButtonPrev",
    componentId: "sc-7661b8e9-5"
})(_templateObject6(), buttonCSS);
var StyledIframeWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledIframeWrap",
    componentId: "sc-7661b8e9-6"
})(_templateObject7());
var StyledIframeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCenterGalleryDialog__StyledIframeContainer",
    componentId: "sc-7661b8e9-7"
})(_templateObject8());
var getYoutubeId = function(url) {
    if (!url) return null;
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
};
var ServiceCenterGalleryDialog = function(param) {
    var onClose = param.onClose, images = param.images, videos = param.videos, active = param.active;
    var nextEl = "SCGallery-nextEl";
    var prevEl = "SCGallery-prevEl";
    var plural = (0,_to_consumable_array/* default */.Z)(images).concat((0,_to_consumable_array/* default */.Z)(videos)).length > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: active != null,
        onClose: onClose,
        PaperProps: {
            style: {
                backgroundColor: "transparent"
            }
        },
        fullScreen: true,
        role: "dialog",
        "aria-modal": true,
        tabIndex: -1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                onClick: onClose,
                "aria-label": "close window"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper, {
                initialSlide: active,
                slidesPerView: 1,
                grabCursor: true,
                modules: [
                    swiper_esm/* Navigation */.W_
                ],
                navigation: {
                    nextEl: ".".concat(nextEl),
                    prevEl: ".".concat(prevEl)
                },
                children: [
                    images.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                src: "".concat(item.imageUrl, "?width=1280"),
                                alt: item.alt || "service center gallery image"
                            })
                        }, i);
                    }),
                    videos.map(function(item, i) {
                        var videoId = getYoutubeId(item.imageUrl);
                        var videoUrl = videoId ? "//www.youtube.com/embed/".concat(videoId) : null;
                        if (!videoUrl) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: function(param) {
                                var isActive = param.isActive;
                                return isActive && videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframeWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframeContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            src: videoUrl,
                                            frameBorder: "0"
                                        })
                                    })
                                });
                            }
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonNext, {
                $visible: plural,
                className: nextEl,
                "aria-label": "לתמונה הבאה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonPrev, {
                $visible: plural,
                className: prevEl,
                "aria-label": "לתמונה הקודמת"
            })
        ]
    });
};
/* harmony default export */ var aboutUs_ServiceCenterGalleryDialog = (/*#__PURE__*/(0,react.memo)(ServiceCenterGalleryDialog));

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/aboutUs/CenterGallery.tsx

function CenterGallery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 40px;\n"
    ]);
    CenterGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CenterGallery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    CenterGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CenterGallery_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 3px;\n  border: 1px solid ",
        "; ;\n"
    ]);
    CenterGallery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CenterGallery_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 4px 0;\n"
    ]);
    CenterGallery_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterGallery__StyledWrapper",
    componentId: "sc-76cc79a7-0"
})(CenterGallery_templateObject());
var CenterGallery_StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "CenterGallery__StyledSwiper",
    componentId: "sc-76cc79a7-1"
})(CenterGallery_templateObject1());
var CenterGallery_StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "CenterGallery__StyledImage",
    componentId: "sc-76cc79a7-2"
})(CenterGallery_templateObject2(), function(p) {
    return p.theme.colors.black;
});
var StyledRatioElement = (0,styled_components_browser_esm/* default */.ZP)(ElementRatio).withConfig({
    displayName: "CenterGallery__StyledRatioElement",
    componentId: "sc-76cc79a7-3"
})(CenterGallery_templateObject3());
var CenterGallery = function(param) {
    var serviceCenter = param.serviceCenter;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(null), active = ref[0], setActive = ref[1];
    if (!serviceCenter.images.length && !serviceCenter.videoUrl.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                $mb: "20px",
                variant: "h3",
                children: "תמונות ממרכז השירות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterGallery_StyledSwiper, {
                spaceBetween: 8,
                slidesPerView: isDesktop ? 9.2 : 3.2,
                slidesOffsetBefore: 2,
                onClick: function(swiper) {
                    setActive(swiper.clickedIndex);
                },
                children: [
                    serviceCenter.images.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            tabIndex: 0,
                            role: "button",
                            style: {
                                marginBottom: 4
                            },
                            "aria-label": "תמונת גלריה לחץ להגדלה",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRatioElement, {
                                ratio: 3 / 2,
                                css: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterGallery_StyledImage, {
                                    src: "".concat(item.imageUrl, "?width=").concat(Math.floor(375 / 3)),
                                    alt: item.alt,
                                    role: "presentation",
                                    "aria-hidden": true
                                })
                            })
                        }, i);
                    }),
                    serviceCenter.videoUrl.map(function(item, i) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRatioElement, {
                                ratio: 3 / 2,
                                css: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterGallery_StyledImage, {
                                    src: "".concat((ref = serviceCenter.videoThumbnailUrl[i]) === null || ref === void 0 ? void 0 : ref.imageUrl, "?width=").concat(Math.floor(375 / 3)),
                                    alt: (ref1 = serviceCenter.videoThumbnailUrl[i]) === null || ref1 === void 0 ? void 0 : ref1.alt
                                })
                            })
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_ServiceCenterGalleryDialog, {
                active: active,
                images: serviceCenter.images,
                videos: serviceCenter.videoUrl,
                onClose: function() {
                    setActive(null);
                }
            })
        ]
    });
};
/* harmony default export */ var aboutUs_CenterGallery = (CenterGallery);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/aboutUs/CenterServices.tsx


var CenterServices = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                    $mb: "20px",
                    variant: "h3",
                    children: "שירותים והתמחויות"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                    $wrap: true,
                    $fullWidth: true,
                    $gap: "20px",
                    children: data.map(function(service, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                            $gap: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                    src: "/icons/Vicon.svg",
                                    w: 13,
                                    h: 9,
                                    alt: "vIcon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                    variant: "body1",
                                    children: service
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var aboutUs_CenterServices = (CenterServices);

// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./reusable/formsComp/FormInput.tsx
var FormInput = __webpack_require__(77498);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/BenefitsSchema.ts


var schema = es/* object */.Ry({
    licenseNumber: FormikSchema/* schemaCommon.licenseNumber */.Cr.licenseNumber
}).defined();
var initialFormState = {
    licenseNumber: ""
};

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/BenefitsForm.tsx



function BenefitsForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    BenefitsForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BenefitsForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n"
    ]);
    BenefitsForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BenefitsForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  /* max-width: 320px; */\n"
    ]);
    BenefitsForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BenefitsForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px;\n"
    ]);
    BenefitsForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var API_URL = "https://api.mazda.co.il";
function formatLicenseNumber(licenceNumber) {
    var num = licenceNumber.split("-").join("");
    if (num.length === 7) {
        num = num.slice(0, 2) + "-" + num.slice(2, 5) + "-" + num.slice(5, 7);
    } else {
        num = num.slice(0, 3) + "-" + num.slice(3, 5) + "-" + num.slice(5, 8);
    }
    return num;
}
var getBenefitUrl = function(licenceNumber, benefit) {
    licenceNumber = formatLicenseNumber(licenceNumber);
    return "".concat(API_URL, "/BenefitPdf?benefitId=").concat(benefit === null || benefit === void 0 ? void 0 : benefit.id, "&serviceCenterName=").concat(encodeURIComponent(benefit === null || benefit === void 0 ? void 0 : benefit.name), "&licenceNumber=").concat(licenceNumber);
};
var BenefitsForm_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BenefitsForm__StyledWrapper",
    componentId: "sc-77d5ae8a-0"
})(BenefitsForm_templateObject());
var StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BenefitsForm__StyledFormDiv",
    componentId: "sc-77d5ae8a-1"
})(BenefitsForm_templateObject1());
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BenefitsForm__StyledWrap",
    componentId: "sc-77d5ae8a-2"
})(BenefitsForm_templateObject2());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "BenefitsForm__StyledButton",
    componentId: "sc-77d5ae8a-3"
})(BenefitsForm_templateObject3());
var BenefitsForm = function(param) {
    var benefit = param.benefit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsForm_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
            validationSchema: schema,
            initialValues: initialFormState,
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                    var url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        url = getBenefitUrl(values.licenseNumber, benefit);
                        window.open(url, "_blank");
                        (0,analytics/* trackSuccessDownload */.Gx)(benefit === null || benefit === void 0 ? void 0 : benefit.name, "benefit_download");
                        return [
                            2
                        ];
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            render: function(formik) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormDiv, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                            name: "licenseNumber",
                            label: "מספר לוחית רישוי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                disabled: formik.isSubmitting,
                                fullWidth: true,
                                variant: "text",
                                type: "submit",
                                children: "הורדת ההטבה"
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var forms_BenefitsForm = (BenefitsForm);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/popups/BenefitPopup.tsx

function BenefitPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  overflow: auto;\n  width: 100%;\n"
    ]);
    BenefitPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BenefitPopup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BenefitPopup__StyledWrapper",
    componentId: "sc-6edfa906-0"
})(BenefitPopup_templateObject());
var BenefitPopup = function(param) {
    var onClose = param.onClose, benefit = param.benefit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPopUp/* default */.Z, {
        open: benefit != null,
        onClose: onClose,
        title: benefit === null || benefit === void 0 ? void 0 : benefit.subject,
        text: benefit === null || benefit === void 0 ? void 0 : benefit.description,
        narrow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitPopup_StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_BenefitsForm, {
                benefit: benefit
            })
        })
    });
};
/* harmony default export */ var popups_BenefitPopup = (BenefitPopup);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/benefits/CenterBenefits.tsx

function CenterBenefits_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CenterBenefits_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CenterBenefits_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: 0 auto;\n  }\n  background-color: ",
        ";\n  border-radius: 6px;\n  padding: 30px 20px 20px;\n  max-width: 277px;\n  border: 0.5px solid ",
        ";\n  border-radius: 6px;\n"
    ]);
    CenterBenefits_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CenterBenefits_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n"
    ]);
    CenterBenefits_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var CenterBenefits_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterBenefits__StyledWrapper",
    componentId: "sc-311e27df-0"
})(CenterBenefits_templateObject());
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterBenefits__StyledCard",
    componentId: "sc-311e27df-1"
})(CenterBenefits_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
}, colors/* default.white */.Z.white, function(p) {
    return p.theme.colors.borderGrey;
});
var StyledCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterBenefits__StyledCardWrapper",
    componentId: "sc-311e27df-2"
})(CenterBenefits_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var CenterBenefits = function(param) {
    var centerBenefits = param.centerBenefits;
    var ref = (0,react.useState)(null), activeBenefit = ref[0], setActiveBenefit = ref[1];
    if (!centerBenefits.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterBenefits_StyledWrapper, {
        children: [
            !!(centerBenefits === null || centerBenefits === void 0 ? void 0 : centerBenefits.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                        $mb: "20px",
                        variant: "h2",
                        $fontSize: "20px",
                        $fontWeight: "300",
                        children: "ההטבות שלנו"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardWrapper, {
                        children: centerBenefits.map(function(benefit) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledCard, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                                    $gap: "20px",
                                    $fullWidth: true,
                                    $justify: "space-between",
                                    $height: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                                            $gap: "10px",
                                            $fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                    variant: "h3",
                                                    $fontSize: "24px",
                                                    $fontWeight: "400",
                                                    children: benefit === null || benefit === void 0 ? void 0 : benefit.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                    variant: "body1",
                                                    children: benefit === null || benefit === void 0 ? void 0 : benefit.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                                            $gap: "20px",
                                            $fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: function() {
                                                        setActiveBenefit(benefit);
                                                        (0,analytics/* trackPopUpOpen */.W1)(benefit === null || benefit === void 0 ? void 0 : benefit.name);
                                                    },
                                                    disableRipple: false,
                                                    disableFocusRipple: false,
                                                    children: "אני רוצה את ההטבה"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                    variant: "caption",
                                                    children: benefit === null || benefit === void 0 ? void 0 : benefit.legalizationComment
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, benefit.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_BenefitPopup, {
                onClose: function() {
                    return setActiveBenefit(null);
                },
                benefit: activeBenefit
            })
        ]
    });
};
/* harmony default export */ var benefits_CenterBenefits = (CenterBenefits);

// EXTERNAL MODULE: ./reusable/formsComp/FormErrorState.tsx + 1 modules
var FormErrorState = __webpack_require__(99763);
// EXTERNAL MODULE: ./reusable/formsComp/FormSuccessState.tsx
var FormSuccessState = __webpack_require__(27047);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/ContentUsSchema.ts


var ContentUsSchema_schema = es/* object */.Ry({
    fullName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    phoneNumber: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    email: FormikSchema/* schemaCommon.email */.Cr.email,
    licenseNumber: FormikSchema/* schemaCommon.licenseNumber */.Cr.licenseNumber,
    message: es/* string */.Z_().max(500, "יש להזין עד 500 תווים בלבד")
}).defined();
var ContentUsSchema_initialFormState = {
    fullName: "",
    phoneNumber: "",
    email: "",
    licenseNumber: "",
    message: ""
};

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/ContentUsForm.tsx



function ContentUsForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    ContentUsForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n"
    ]);
    ContentUsForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  .MuiOutlinedInput-multiline {\n    padding: 15px 14px;\n  }\n"
    ]);
    ContentUsForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n  }\n"
    ]);
    ContentUsForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 320px;\n"
    ]);
    ContentUsForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    ContentUsForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ContentUsForm_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  textarea {\n    height: 94px !important;\n  }\n"
    ]);
    ContentUsForm_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var ContentUsForm_StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsForm__StyledFormDiv",
    componentId: "sc-e9304653-0"
})(ContentUsForm_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var ContentUsForm_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ContentUsForm__StyledButton",
    componentId: "sc-e9304653-1"
})(ContentUsForm_templateObject1());
var StyledCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsForm__StyledCol",
    componentId: "sc-e9304653-2"
})(ContentUsForm_templateObject2());
var StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsForm__StyledRowCol",
    componentId: "sc-e9304653-3"
})(ContentUsForm_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ContentUsForm_StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsForm__StyledWrap",
    componentId: "sc-e9304653-4"
})(ContentUsForm_templateObject4());
var StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ContentUsForm__StyledRequiredFields",
    componentId: "sc-e9304653-5"
})(ContentUsForm_templateObject5(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
    displayName: "ContentUsForm__StyledFormInput",
    componentId: "sc-e9304653-6"
})(ContentUsForm_templateObject6());
var ContentUsForm = function(param) {
    var centerData = param.centerData, setFormStatus = param.setFormStatus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
        validationSchema: ContentUsSchema_schema,
        initialValues: ContentUsSchema_initialFormState,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,api/* postServiceCenterContact */.hF)({
                                    name: values.fullName,
                                    mobilePhone: values.phoneNumber,
                                    serviceCenterId: centerData.id,
                                    applicationType: "Contact",
                                    rishui: values.licenseNumber,
                                    email: centerData.email,
                                    customerEmail: values.email,
                                    content: values.message,
                                    treatmentDate: null,
                                    treatmentTime: null,
                                    treatmentType: "Default"
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data.body) {
                                setFormStatus(FormStatus.Success);
                                (0,analytics/* trackSuccessLead */.KZ)("יצירת קשר", "service_center_lead_success");
                            } else {
                                setFormStatus(FormStatus.Error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            setFormStatus(FormStatus.Error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        render: function(formik) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentUsForm_StyledFormDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequiredFields, {
                        children: "* שדות חובה"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCol, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "fullName",
                                        label: "שם מלא",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("יצירת קשר", "fullName");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "phoneNumber",
                                        type: "tel",
                                        label: "טלפון נייד",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("יצירת קשר", "phoneNumber");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "email",
                                        label: "כתובת מייל",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("יצירת קשר", "email");
                                        },
                                        type: "email"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCol, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "licenseNumber",
                                        label: "מספר לוחית רישוי",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("יצירת קשר", "licenseNumber");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                        name: "message",
                                        label: "?איך נוכל לעזור",
                                        multiline: true,
                                        minRows: 5,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("יצירת קשר", "message");
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentUsForm_StyledWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentUsForm_StyledButton, {
                            disabled: formik.isSubmitting,
                            fullWidth: true,
                            variant: "text",
                            type: "submit",
                            children: "שליחה"
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var forms_ContentUsForm = (ContentUsForm);

// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./components/mapPages/CardRowText.tsx
var CardRowText = __webpack_require__(94316);
;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/popups/PopUpHeaderUi.tsx

function PopUpHeaderUi_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    PopUpHeaderUi_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PopUpHeaderUi_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PopUpHeaderUi__StyledWrapper",
    componentId: "sc-93ec5453-0"
})(PopUpHeaderUi_templateObject());
var PopUpHeaderUi = function(param) {
    var centerData = param.centerData, type = param.type;
    var formatPhoneNumber = function formatPhoneNumber(phone) {
        var cleaned = ("" + phone).replace(/\D/g, "");
        // For mobile numbers (10 digits): 052-447-7428
        if (cleaned.length === 10) {
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "".concat(match[1], "-").concat(match[2]).concat(match[3]);
            }
        }
        // For landline numbers (9 digits): 08-926-2099
        if (cleaned.length === 9) {
            var match1 = cleaned.match(/^(\d{2})(\d{3})(\d{4})$/);
            if (match1) {
                return "".concat(match1[1], "-").concat(match1[2]).concat(match1[3]);
            }
        }
        return phone;
    };
    var trackPhoneClick = function() {
        (0,analytics/* trackServiceCenterPhoneClick */.jr)(type, centerData.name, "phone_number_popup_clicks");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopUpHeaderUi_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                $gap: "30px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: formatPhoneNumber(centerData.phone),
                        link: "tel:".concat(centerData.phone),
                        iconName: "phoneCall",
                        imageAlt: "טלפון",
                        trackEvent: trackPhoneClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: formatPhoneNumber(centerData.fax),
                        iconName: "fax",
                        imageAlt: "פקס"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                    data: centerData.address
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: centerData.wazeLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        children: "ניווט ב-Waze"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var popups_PopUpHeaderUi = (PopUpHeaderUi);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/popups/ContentUsPopup.tsx

function ContentUsPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  overflow: auto;\n  margin-top: -15px;\n"
    ]);
    ContentUsPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentUsPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    ContentUsPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ContentUsPopup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsPopup__StyledWrapper",
    componentId: "sc-c89c3fd0-0"
})(ContentUsPopup_templateObject());
var StyledWrapperForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentUsPopup__StyledWrapperForm",
    componentId: "sc-c89c3fd0-1"
})(ContentUsPopup_templateObject1());
var FormStatus;
(function(FormStatus) {
    FormStatus["Normal"] = "normal";
    FormStatus["Success"] = "success";
    FormStatus["Error"] = "error";
})(FormStatus || (FormStatus = {}));
var ContentUsPopup = function(param) {
    var onClose = param.onClose, open = param.open, centerData = param.centerData;
    var ref = (0,react.useState)(FormStatus.Normal), formStatus = ref[0], setFormStatus = ref[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPopUp/* default */.Z, {
        open: open,
        onClose: onClose,
        title: centerData.name,
        padding: isDesktop ? "20px" : "0px",
        arialabelledby: "חלונית קביעת תור",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentUsPopup_StyledWrapper, {
            children: [
                formStatus === FormStatus.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_PopUpHeaderUi, {
                    centerData: centerData,
                    type: "יצירת קשר"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperForm, {
                    children: [
                        formStatus === FormStatus.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_ContentUsForm, {
                            centerData: centerData,
                            setFormStatus: setFormStatus
                        }),
                        formStatus === FormStatus.Error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorState/* default */.ZP, {}),
                        formStatus === FormStatus.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var popups_ContentUsPopup = (ContentUsPopup);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getDay/index.js
var getDay = __webpack_require__(20466);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setHours/index.js
var setHours = __webpack_require__(37042);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setMinutes/index.js
var setMinutes = __webpack_require__(4543);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getHours/index.js
var getHours = __webpack_require__(85817);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/he/index.js + 5 modules
var he = __webpack_require__(94433);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
;// CONCATENATED MODULE: ./reusable/formsComp/DateTimeInput.tsx



function DateTimeInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 81.6px;\n  display: flex;\n  width: 100%;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n"
    ]);
    DateTimeInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DateTimeInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: -0.5em;\n  right: 0px;\n  font-size: 12px !important;\n  height: 15.594px;\n  margin-top: 3px;\n"
    ]);
    DateTimeInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DateTimeInput_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  width: 100%;\n  .react-datepicker-popper {\n    z-index: 10;\n  }\n  * {\n    font-family: MazdaType, OENaPro, sans-serif;\n  }\n  .react-datepicker__time-list-item--selected {\n    background-color: ",
        " !important;\n  }\n  .react-datepicker__day--selected {\n    background-color: ",
        " !important;\n  }\n  .react-datepicker__header {\n    background-color: ",
        " !important;\n  }\n"
    ]);
    DateTimeInput_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






// import { TextField } from "formik-material-ui"




// https://reactdatepicker.com/
var DateTimeInput_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimeInput__StyledWrapper",
    componentId: "sc-a351bdee-0"
})(DateTimeInput_templateObject());
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(FormHelperText/* default */.Z).withConfig({
    displayName: "DateTimeInput__StyledError",
    componentId: "sc-a351bdee-1"
})(DateTimeInput_templateObject1());
var StyledPickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimeInput__StyledPickerWrapper",
    componentId: "sc-a351bdee-2"
})(DateTimeInput_templateObject2(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.colors.lightGrey;
});
var DateTimeInput = function(param) {
    var name = param.name, label = param.label, minTime = param.minTime, maxTime = param.maxTime, disable = param.disable, isWorkingFriday = param.isWorkingFriday;
    // formik
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm.useField)(name), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var value = meta.value, error = meta.error, touched = meta.touched;
    var setValue = helpers.setValue;
    // states:
    var ref1 = (0,react.useState)(value), date = ref1[0], setDate = ref1[1];
    var ref2 = (0,react.useRef)(null);
    // Filter dates
    var isWeekday = function(date) {
        var day = (0,getDay["default"])(date);
        if (isWorkingFriday) {
            return day !== 6;
        }
        return day !== 5 && day !== 6;
    };
    // Filter times
    var filterPassedTime = function(time) {
        var currentDate = new Date();
        var selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    };
    var getDateTwoDaysFromNow = function() {
        var now = new Date();
        var twoDaysFromNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2);
        return twoDaysFromNow;
    };
    var minDate = getDateTwoDaysFromNow();
    var resetSelectedDate = function() {
        setDate(null);
        setValue(null);
    };
    (0,react.useEffect)(function() {
        if (date) {
            if ((0,startOfDay["default"])(date).getTime() < (0,startOfDay["default"])(minDate).getTime()) {
                console.log("date is before minDate");
                resetSelectedDate();
            } else {
                setValue(date);
            }
        }
    }, [
        date
    ]);
    // Reset date when time constraints change
    (0,react.useEffect)(function() {
        if (date) {
            // Check if the current selected time is outside the new constraints
            var selectedDate = new Date(date);
            var selectedHours = selectedDate.getHours();
            var isTimeInvalid = minTime && selectedHours < minTime || maxTime && selectedHours > maxTime;
            if (isTimeInvalid) {
                setDate(null);
                setValue(null);
            }
        }
    }, [
        minTime,
        maxTime
    ]);
    (0,react_datepicker_min.setDefaultLocale)("he_IL");
    (0,react_datepicker_min.registerLocale)("he_IL", he/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DateTimeInput_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPickerWrapper, {
                $default: date,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                    customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        label: label
                    }, field)),
                    required: true,
                    ref: ref2,
                    locale: "he_IL",
                    className: "form-control",
                    selected: date ? date : "",
                    onChange: function(date) {
                        setDate(date);
                    },
                    value: date,
                    name: name,
                    onCalendarOpen: function() {
                        (0,analytics/* trackPopUpClicks */.dC)("קביעת ביקור", "treatmentDate");
                    },
                    // date:
                    dateFormat: "dd/MM/yy, HH:mm",
                    // maxDate={twoWeeksFromNow}
                    minDate: minDate,
                    filterDate: isWeekday,
                    //time:
                    showTimeSelect: true,
                    timeIntervals: 30,
                    timeFormat: "HH:mm",
                    timeCaption: "שעה",
                    minTime: minTime && (0,setHours["default"])((0,setMinutes["default"])(new Date(), 0), minTime),
                    maxTime: maxTime && (0,setHours["default"])((0,setMinutes["default"])(new Date(), 0), maxTime),
                    filterTime: filterPassedTime,
                    autoComplete: "off",
                    disabled: disable,
                    onCalendarClose: function() {
                        if ((0,getHours["default"])(date) < minTime) {
                            resetSelectedDate();
                        }
                    }
                })
            }),
            error && touched ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                id: "".concat(name, "-helper-text"),
                error: true,
                children: error
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                id: "".concat(name, "-helper-text"),
                children: "  "
            })
        ]
    });
};
/* harmony default export */ var formsComp_DateTimeInput = (DateTimeInput);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/TreatmentSchema.ts


var treatmentTypes = [
    {
        id: "PeriodicTreatment",
        name: "טיפול תקופתי",
        minMaxTime: {
            minTime: 7,
            maxTime: 9
        }
    },
    {
        id: "Problem",
        name: "תקלה",
        minMaxTime: {
            minTime: 9,
            maxTime: 11
        }
    },
    {
        id: "Accident",
        name: "תאונה",
        minMaxTime: {
            minTime: 9,
            maxTime: 11
        }
    }, 
];
var generalMaxMinTime = {
    minTime: 10,
    maxTime: 14
};
var ACCIDENT_DESCRIPTION_MAX_LENGTH = 300;
var PROBLEM_DESCRIPTION_MAX_LENGTH = 300;
var TreatmentSchema_schema = es/* object */.Ry({
    fullName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    phoneNumber: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    licenseNumber: FormikSchema/* schemaCommon.licenseNumber */.Cr.licenseNumber,
    treatmentDate: es/* mixed */.nK().required("שדה חובה"),
    treatmentType: es/* mixed */.nK().required("שדה חובה"),
    problemDescription: es/* string */.Z_().when("treatmentType", {
        is: "Problem",
        then: function(schema) {
            return schema.required("שדה חובה").max(PROBLEM_DESCRIPTION_MAX_LENGTH, "מקסימום תווים ".concat(PROBLEM_DESCRIPTION_MAX_LENGTH, " characters"));
        },
        otherwise: function(schema) {
            return schema.max(PROBLEM_DESCRIPTION_MAX_LENGTH, "מקסימום תווים ".concat(PROBLEM_DESCRIPTION_MAX_LENGTH, " characters"));
        }
    })
}).defined();
var TreatmentSchema_initialFormState = {
    fullName: "",
    phoneNumber: "",
    licenseNumber: "",
    treatmentDate: null,
    treatmentType: null,
    problemDescription: ""
};

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/forms/TreatmentForm.tsx



function TreatmentForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  .MuiSelect-nativeInput {\n    opacity: ",
        ";\n    border: none;\n    height: 100%;\n    ::placeholder {\n      color: rgba(16, 16, 16, 1);\n      font-size: 18px;\n      padding-right: 10px;\n      font-family: MazdaType, OENaPro, sans-serif;\n    }\n  }\n  label {\n    font-family: MazdaType, OENaPro, sans-serif;\n  }\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    TreatmentForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"
    ]);
    TreatmentForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n  }\n"
    ]);
    TreatmentForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  ",
        " {\n    height: 81.6px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n"
    ]);
    TreatmentForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 4px;\n    height: 41px;\n  }\n"
    ]);
    TreatmentForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    TreatmentForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TreatmentForm_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* margin-left: auto; */\n"
    ]);
    TreatmentForm_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}













var DATE_FORMAT = "dd/MM/yyyy";
var TIME_FORMAT = "HH:mm";
var TreatmentForm_StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentForm__StyledFormDiv",
    componentId: "sc-b07a7aa6-0"
})(TreatmentForm_templateObject(), function(p) {
    return p.$hide ? 0 : 1;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var TreatmentForm_StyledCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentForm__StyledCol",
    componentId: "sc-b07a7aa6-1"
})(TreatmentForm_templateObject1());
var TreatmentForm_StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentForm__StyledRowCol",
    componentId: "sc-b07a7aa6-2"
})(TreatmentForm_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var TreatmentForm_StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentForm__StyledWrap",
    componentId: "sc-b07a7aa6-3"
})(TreatmentForm_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var TreatmentForm_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "TreatmentForm__StyledButton",
    componentId: "sc-b07a7aa6-4"
})(TreatmentForm_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var TreatmentForm_StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "TreatmentForm__StyledRequiredFields",
    componentId: "sc-b07a7aa6-5"
})(TreatmentForm_templateObject5(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledRecallComment = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "TreatmentForm__StyledRecallComment",
    componentId: "sc-b07a7aa6-6"
})(TreatmentForm_templateObject6());
var TreatmentForm = function(param) {
    var centerData = param.centerData, setFormStatus = param.setFormStatus;
    var ref = (0,react.useState)(), treatmentTimeMinMax = ref[0], setTreatmentTimeMinMax = ref[1];
    // Check if service center works on Friday (ו)
    // const isWorkingFriday = Object.values(centerData.schedule || {}).some(
    //   (days) => days.includes("ו")
    // )
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
        validationSchema: TreatmentSchema_schema,
        initialValues: TreatmentSchema_initialFormState,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,api/* postServiceCenterContact */.hF)({
                                    name: values.fullName,
                                    mobilePhone: values.phoneNumber,
                                    serviceCenterId: centerData.id,
                                    applicationType: "Treatment",
                                    rishui: values.licenseNumber,
                                    email: centerData.email,
                                    customerEmail: null,
                                    content: values.problemDescription,
                                    treatmentDate: (0,format["default"])(values.treatmentDate, DATE_FORMAT),
                                    treatmentTime: (0,format["default"])(values.treatmentDate, TIME_FORMAT),
                                    treatmentType: values.treatmentType
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data.body) {
                                (0,analytics/* trackSuccessLead */.KZ)("קביעת ביקור", "service_center_lead_success");
                                setFormStatus(FormStatus.Success);
                            } else {
                                setFormStatus(FormStatus.Error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            setFormStatus(FormStatus.Error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        render: function(formik) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TreatmentForm_StyledFormDiv, {
                $hide: formik.values.treatmentType,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecallComment, {
                        children: "לביצוע קריאה חוזרת (ריקול) יש לתאם טלפונית עם מרכז השירות."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentForm_StyledRequiredFields, {
                        children: "* שדות חובה"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentForm_StyledRowCol, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentForm_StyledCol, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "fullName",
                                        label: "שם מלא",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("קביעת ביקור", "fullName");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                        name: "treatmentType",
                                        required: true,
                                        label: "סוג טיפול",
                                        values: treatmentTypes,
                                        map: function(item) {
                                            return {
                                                id: item.id,
                                                name: item.name
                                            };
                                        },
                                        onClick: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("קביעת ביקור", "treatmentType");
                                        },
                                        onChange: function(event) {
                                            formik.setFieldValue("treatmentType", event.target.value);
                                            var treatmentType = treatmentTypes.find(function(type) {
                                                return type.id === event.target.value;
                                            });
                                            if (!centerData.isMainGarage) {
                                                setTreatmentTimeMinMax(generalMaxMinTime);
                                            } else if (treatmentType) {
                                                setTreatmentTimeMinMax(treatmentType.minMaxTime);
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "licenseNumber",
                                        label: "מספר לוחית רישוי",
                                        required: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("קביעת ביקור", "licenseNumber");
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentForm_StyledCol, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "phoneNumber",
                                        label: "טלפון נייד",
                                        required: true,
                                        type: "tel",
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("קביעת ביקור", "phoneNumber");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formsComp_DateTimeInput, {
                                        name: "treatmentDate",
                                        label: "בחירת מועד הגעה",
                                        minTime: treatmentTimeMinMax === null || treatmentTimeMinMax === void 0 ? void 0 : treatmentTimeMinMax.minTime,
                                        maxTime: treatmentTimeMinMax === null || treatmentTimeMinMax === void 0 ? void 0 : treatmentTimeMinMax.maxTime,
                                        disable: !treatmentTimeMinMax
                                    }),
                                    formik.values.treatmentType === "Problem" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                        name: "problemDescription",
                                        label: "פירוט התקלה",
                                        required: true,
                                        multiline: true,
                                        onFocusCapture: function() {
                                            return (0,analytics/* trackPopUpClicks */.dC)("פירוט התקלה", "problemDescription");
                                        },
                                        maxLength: PROBLEM_DESCRIPTION_MAX_LENGTH
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentForm_StyledWrap, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentForm_StyledButton, {
                                            disabled: formik.isSubmitting,
                                            fullWidth: true,
                                            variant: "text",
                                            type: "submit",
                                            children: "שליחה"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var forms_TreatmentForm = (TreatmentForm);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/popups/TreatmentPopup.tsx

function TreatmentPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    TreatmentPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TreatmentPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  overflow: auto;\n  margin-top: -15px;\n"
    ]);
    TreatmentPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var TreatmentPopup_StyledWrapperForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentPopup__StyledWrapperForm",
    componentId: "sc-22d456b8-0"
})(TreatmentPopup_templateObject());
var TreatmentPopup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TreatmentPopup__StyledWrapper",
    componentId: "sc-22d456b8-1"
})(TreatmentPopup_templateObject1());
var TreatmentPopup_FormStatus;
(function(FormStatus) {
    FormStatus["Normal"] = "normal";
    FormStatus["Success"] = "success";
    FormStatus["Error"] = "error";
})(TreatmentPopup_FormStatus || (TreatmentPopup_FormStatus = {}));
var TreatmentPopup = function(param) {
    var onClose = param.onClose, open = param.open, centerData = param.centerData;
    var ref = (0,react.useState)(TreatmentPopup_FormStatus.Normal), formStatus = ref[0], setFormStatus = ref[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPopUp/* default */.Z, {
        open: open,
        onClose: onClose,
        title: centerData.name,
        padding: isDesktop ? "20px" : "0px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentPopup_StyledWrapper, {
            children: [
                formStatus === TreatmentPopup_FormStatus.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_PopUpHeaderUi, {
                    centerData: centerData,
                    type: "קביעת ביקור"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentPopup_StyledWrapperForm, {
                    children: [
                        formStatus === TreatmentPopup_FormStatus.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_TreatmentForm, {
                            centerData: centerData,
                            setFormStatus: setFormStatus
                        }),
                        formStatus === TreatmentPopup_FormStatus.Error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorState/* default */.ZP, {}),
                        formStatus === TreatmentPopup_FormStatus.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {
                            title: "תודה שקבעת תור.",
                            subtitle: "ברגע שההזמנה שלך תאושר, תקבל/י SMS עם כל פרטי התור שלך.\nטיפ: יש לוודא שהמספר הנייד שציינת מעודכן"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var popups_TreatmentPopup = (TreatmentPopup);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/profile/SocialIconButton.tsx



var SocialIconButton = function(param) {
    var link = param.link, iconName = param.iconName, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: link && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            href: link,
            passHref: true,
            openInNewTab: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                src: "/icons/".concat(iconName, ".svg"),
                alt: alt ? alt : "icon-button",
                w: 20,
                h: 20
            })
        })
    });
};
/* harmony default export */ var profile_SocialIconButton = (SocialIconButton);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/profile/CenterProfile.tsx



function CenterProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  ",
        " {\n    flex-direction: row;\n    gap: 100px;\n  }\n"
    ]);
    CenterProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CenterProfile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: start;\n  font-size: 24px;\n  font-weight: 400;\n"
    ]);
    CenterProfile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CenterProfile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  display: inline-block;\n"
    ]);
    CenterProfile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CenterProfile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 140px;\n  height: 110px;\n  border: 0.53125px solid ",
        ";\n  border-radius: 8.5px;\n  overflow: hidden;\n  margin-bottom: 8px;\n"
    ]);
    CenterProfile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var CenterProfile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterProfile__StyledWrapper",
    componentId: "sc-42678557-0"
})(CenterProfile_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledCarHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterProfile__StyledCarHeadline",
    componentId: "sc-42678557-1"
})(CenterProfile_templateObject1());
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "CenterProfile__StyledHeadline",
    componentId: "sc-42678557-2"
})(CenterProfile_templateObject2());
var StyledImageWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CenterProfile__StyledImageWrap",
    componentId: "sc-42678557-3"
})(CenterProfile_templateObject3(), function(p) {
    return p.theme.colors.darkGrey;
});
var CenterProfile = function(param) {
    var centerData = param.centerData, openTreatmentFunc = param.openTreatmentFunc, openContentUsFunc = param.openContentUsFunc;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterProfile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                $notCenter: true,
                children: [
                    (centerData === null || centerData === void 0 ? void 0 : (ref = centerData.logo) === null || ref === void 0 ? void 0 : ref.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: centerData === null || centerData === void 0 ? void 0 : centerData.logo.imageUrl,
                            alt: "דלק מוטורס",
                            width: 140,
                            height: 110,
                            objectFit: "contain",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarHeadline, {
                        children: centerData === null || centerData === void 0 ? void 0 : centerData.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                        $gap: "15px",
                        $fullWidth: true,
                        $mt: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    openTreatmentFunc();
                                },
                                children: "קביעת ביקור"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    openContentUsFunc();
                                },
                                variant: "outlined",
                                children: "יצירת קשר"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                $gap: "15px",
                $fullWidth: true,
                $notCenter: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: centerData.address,
                        iconName: "mazdaLocationIcon",
                        imageAlt: "מיקום"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: centerData.whatsapp,
                        link: centerData.whatsappLink,
                        iconName: "whatsappLogo",
                        imageAlt: "ווטסאפ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: centerData.phone,
                        link: "tel:".concat(centerData.phone),
                        iconName: "phoneCall",
                        imageAlt: "טלפון"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: centerData.fax,
                        iconName: "fax",
                        imageAlt: "פקס"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: centerData.email,
                        link: "mailto:".concat(centerData.email),
                        iconName: "mailIcon",
                        imageAlt: "מייל"
                    })
                ]
            }),
            (centerData === null || centerData === void 0 ? void 0 : centerData.workingSchedule) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                $notCenter: true,
                $fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                        $gap: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                src: "/icons/clock.svg",
                                alt: "שעות פעילות",
                                w: 20,
                                h: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                                children: "שעות פעילות"
                            })
                        ]
                    }),
                    Object.entries(centerData.workingSchedule).map(function(param, i) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), time = _param[0], days = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                            $mt: "5px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                                data: "".concat((0,_to_consumable_array/* default */.Z)(days).join(", "), " : ").concat(time)
                            })
                        }, i);
                    }),
                    (centerData.siteName || centerData.twitter || centerData.instegram || centerData.facebook) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                        $mt: "17px",
                        $gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                                children: "בקרו אותנו"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_SocialIconButton, {
                                link: centerData.siteName,
                                iconName: "social/website",
                                alt: "website icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_SocialIconButton, {
                                link: centerData.twitter,
                                iconName: "social/twitter",
                                alt: "twitter icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_SocialIconButton, {
                                link: centerData.instegram,
                                iconName: "social/insta",
                                alt: "instagram icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_SocialIconButton, {
                                link: centerData.facebook,
                                iconName: "social/facebook",
                                alt: "facebook icon"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var profile_CenterProfile = (CenterProfile);

;// CONCATENATED MODULE: ./components/mapPages/singleServiceCenter/SingleServiceCenterPage.tsx

function SingleServiceCenterPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n  position: relative;\n  ",
        " {\n    margin-top: 5px;\n    gap: 5px;\n  }\n"
    ]);
    SingleServiceCenterPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SingleServiceCenterPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  ",
        " {\n    margin: 0 -20px;\n    padding: 30px 20px;\n  }\n  ",
        " {\n    padding: 30px;\n    border-radius: 10px;\n  }\n"
    ]);
    SingleServiceCenterPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SingleServiceCenterPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    background: none;\n  }\n  width: 100px;\n  height: 40px;\n  ",
        " {\n    justify-content: right;\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    SingleServiceCenterPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SingleServiceCenterPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: ",
        ";\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  ",
        ";\n  -webkit-box-orient: vertical;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  color: #101010;\n"
    ]);
    SingleServiceCenterPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SingleServiceCenterPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: no-repeat;\n  border: none;\n  font-size: 18px;\n  color: #4c607e;\n  text-decoration: underline;\n  justify-content: right;\n  padding: 0px;\n  margin-bottom: 40px;\n  &:hover {\n    background: none;\n    outline: none;\n    border: none;\n    color: #4c607e;\n    text-decoration: underline;\n  }\n"
    ]);
    SingleServiceCenterPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var StyledContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SingleServiceCenterPage__StyledContentWrap",
    componentId: "sc-76bedce7-0"
})(SingleServiceCenterPage_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWhiteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SingleServiceCenterPage__StyledWhiteWrapper",
    componentId: "sc-76bedce7-1"
})(SingleServiceCenterPage_templateObject1(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "SingleServiceCenterPage__StyledIconButton",
    componentId: "sc-76bedce7-2"
})(SingleServiceCenterPage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledCenterData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SingleServiceCenterPage__StyledCenterData",
    componentId: "sc-76bedce7-3"
})(SingleServiceCenterPage_templateObject3(), function(p) {
    return p.$showLess ? "auto" : "hidden";
}, function(p) {
    return !p.$showLess && "-webkit-line-clamp: 3";
});
var StyledShowMoreBtn = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "SingleServiceCenterPage__StyledShowMoreBtn",
    componentId: "sc-76bedce7-4"
})(SingleServiceCenterPage_templateObject4());
var SingleServiceCenterPage = function(param) {
    var centerData = param.centerData;
    var ref = (0,react.useState)(false), openContentUs = ref[0], setOpenContentUsPopup = ref[1];
    var ref1 = (0,react.useState)(false), openTreatment = ref1[0], setOpenTreatment = ref1[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var containerRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), showMore = ref2[0], setShowMore = ref2[1];
    var ref3 = (0,react.useState)(false), showLess = ref3[0], setShowLess = ref3[1];
    (0,react.useEffect)(function() {
        if (containerRef && containerRef.current && containerRef.current.scrollHeight > containerRef.current.clientHeight) {
            setShowMore(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPageWrapper/* default */.Z, {
        imgUrl: (centerData === null || centerData === void 0 ? void 0 : centerData.imagePath) ? centerData === null || centerData === void 0 ? void 0 : centerData.imagePath : isDesktop ? "/img/cover/Servicecenters.jpg" : "/img/cover/Servicecentersmobile.jpg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        name: "ServicesCenters",
                        page: "singleService"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        role: "link",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhiteWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_CenterProfile, {
                            centerData: centerData,
                            openTreatmentFunc: function() {
                                setOpenTreatment(true);
                                (0,analytics/* trackPopUpOpen */.W1)("קביעת ביקור");
                            },
                            openContentUsFunc: function() {
                                setOpenContentUsPopup(true);
                                (0,analytics/* trackPopUpOpen */.W1)("יצירת קשר");
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhiteWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_CenterBenefits, {
                            centerBenefits: centerData.benefits
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhiteWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                        $mb: "20px",
                                        variant: "h2",
                                        $fontSize: "20px",
                                        $fontWeight: "300",
                                        children: "אודות מרכז השירות"
                                    }),
                                    centerData.description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCenterData, {
                                                ref: containerRef,
                                                $showLess: showLess,
                                                dangerouslySetInnerHTML: {
                                                    __html: centerData.description
                                                }
                                            }),
                                            showMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShowMoreBtn, {
                                                onClick: function() {
                                                    setShowMore(false);
                                                    setShowLess(true);
                                                },
                                                children: "קרא עוד"
                                            }),
                                            showLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShowMoreBtn, {
                                                onClick: function() {
                                                    setShowMore(true);
                                                    setShowLess(false);
                                                },
                                                children: "קרא פחות"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CenterServices, {
                                data: centerData === null || centerData === void 0 ? void 0 : centerData.services
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CenterGallery, {
                                serviceCenter: centerData
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_ContentUsPopup, {
                centerData: centerData,
                open: openContentUs,
                onClose: function() {
                    return setOpenContentUsPopup(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_TreatmentPopup, {
                centerData: centerData,
                open: openTreatment,
                onClose: function() {
                    return setOpenTreatment(false);
                }
            })
        ]
    });
};
/* harmony default export */ var singleServiceCenter_SingleServiceCenterPage = (SingleServiceCenterPage);

;// CONCATENATED MODULE: ./src/pages/service-center/[serviceCenterId]/[serviceCenterSlug].tsx



var ServiceCenter = function(param) {
    var serviceCenter = param.serviceCenter, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(singleServiceCenter_SingleServiceCenterPage, {
                centerData: serviceCenter
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _serviceCenterSlug_ = (ServiceCenter);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,4856,999,4839,9774,2888,179], function() { return __webpack_exec__(81815); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);